import { createFileRoute } from '@tanstack/react-router'
import { EmployeeCenterShell } from '@/components/employee-center/EmployeeCenterEmployeeShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center',
)({
  component: RouteComponent,
  staticData: {
    pageHeader: { title: 'Employee Center', customHeader: true, pad: false },
  },
})

function RouteComponent() {
  return <EmployeeCenterShell />
}
